import { render, staticRenderFns } from "./StartupPhase.vue?vue&type=template&id=efa3d7e8&scoped=true"
import script from "./StartupPhase.vue?vue&type=script&lang=js"
export * from "./StartupPhase.vue?vue&type=script&lang=js"
import style0 from "./StartupPhase.vue?vue&type=style&index=0&id=efa3d7e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efa3d7e8",
  null
  
)

export default component.exports